var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretClosedDown = function SvgCaretClosedDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "m13.354 6.354-5 5a.5.5 0 0 1-.707 0l-5-5A.5.5 0 0 1 3 5.5h10a.5.5 0 0 1 .354.854"
  })));
};
export default SvgCaretClosedDown;